export default {
  en: {
    'components.game-changer.distance-sales-selector.title': 'Distance selling',
    'components.game-changer.distance-sales-selector.subtitle':
      'Please select jurisdictions considered as distance selling destinations:',
    'components.game-changer.distance-sales-selector.select-all': 'Select all',
    'components.game-changer.distance-sales-selector.select-none': 'Select none',
    'components.game-changer.distance-sales-selector.no-results':
      'No matching jurisdictions found.',
    'components.game-changer.distance-sales-selector.run': 'Run',
    'components.game-changer.distance-sales-selector.active':
      '{count, plural, one {# jurisdiction} other {# jurisdictions}} selected',
  },
};
